import React from "react";
import LegalShell, { LegalSection } from "./LegalShell";
import { LEGAL } from "../../lib/legalConfig";

/**
 * /legal/why-sof — "Why we ask for Source of Funds" explainer.
 *
 * ⚠️ LAWYER-APPROVED COPY (5 February 2026). No threshold figures —
 * deliberate.
 */
export default function WhySofPage() {
  return (
    <LegalShell
      title="Why we ask for Source of Funds"
      effectiveDate={LEGAL.WHY_SOF_EFFECTIVE_DATE}
      lastUpdated={LEGAL.WHY_SOF_EFFECTIVE_DATE}
      testid="legal-why-sof"
      intro={
        <>
          A short, plain-language explainer for customers who've been asked
          for documents about where their funds come from.
        </>
      }
    >
      <LegalSection id="seeing" title="Why you're seeing this">
        <p>
          If we've asked you for information or documents about your source
          of funds, it's a normal and legally required part of using a
          regulated service — not a sign that anything is wrong. As a
          regulated service, Xchangely is required by
          law to understand, in certain circumstances, where
          customer funds come from. This protects you, protects other
          customers, and protects the financial system from money laundering
          and fraud.
        </p>
      </LegalSection>

      <LegalSection id="what-we-ask" title="What we might ask for">
        <p>
          Depending on the situation, we may ask for a short explanation of
          where your funds come from and/or supporting documents such as a
          recent bank statement, a payslip, or another reasonable proof. We
          only ask for what we need, and your documents are handled securely
          and kept confidential in line with our Privacy Policy.
        </p>
      </LegalSection>

      <LegalSection id="next" title="What happens next">
        <p>
          Once you've provided what we asked for, our team reviews it. In
          most cases this is quick. If we need anything further, we'll let
          you know. Until a required source-of-funds check is completed, the
          relevant purchase may be paused.
        </p>
      </LegalSection>

      <LegalSection id="data-protection" title="Your data is protected">
        <p>
          Documents you provide are encrypted, access-restricted, and
          retained only as required by law, then securely deleted. See our
          Privacy Policy for details.
        </p>
      </LegalSection>

      <LegalSection id="questions" title="Questions">
        <p>We're happy to help: support@xchangely.io.</p>
      </LegalSection>
    </LegalShell>
  );
}
